export default function _cloneRegExp(pattern) {
                                  return new RegExp(pattern.source, (pattern.global ? 'g' : '') + (pattern.ignoreCase ? 'i' : '') + (pattern.multiline ? 'm' : '') + (pattern.sticky ? 'y' : '') + (pattern.unicode ? 'u' : ''));
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/ramda/es/internal/_cloneRegExp.js
// module id = ../node_modules/ramda/es/internal/_cloneRegExp.js
// module chunks = 5